import { render } from "./tenantDeleteConformationDialog.vue?vue&type=template&id=41dfce90"
import script from "./tenantDeleteConformationDialog.vue?vue&type=script&lang=js"
export * from "./tenantDeleteConformationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__